import React from 'react'

const Editcategory = () => {
  return (
    <div>
      EditCategory
    </div>
  )
}

export default Editcategory
